document.addEventListener('DOMContentLoaded', () => {
  const phoneLink = document.querySelector('.phone-link');
  const phoneIcon = document.querySelector('.phone-icon');
  if (!phoneLink || !phoneIcon) return;

  // Toujours blanc au départ
  phoneLink.classList.remove('scrolled');
  phoneIcon.classList.remove('scrolled');

  function updatePhoneColor() {
    if (window.scrollY > 20) {
      phoneLink.classList.add('scrolled');
      phoneIcon.classList.add('scrolled');
    } else {
      phoneLink.classList.remove('scrolled');
      phoneIcon.classList.remove('scrolled');
    }
  }

  // Exécute au chargement + scroll
  window.addEventListener('load', updatePhoneColor);
  window.addEventListener('scroll', updatePhoneColor);
  window.addEventListener('resize', updatePhoneColor);
});
